// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"cbb124fe","453":"61f4003e"}[chunkId] + ".chunk.js";
};